<template>
  <div class="page-error">
    <div class="title">{{ $t('PageError_Title') }}</div>
    <div class="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: 'PageError',
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.page-error {
  text-align: center;
  height: 160px;
  margin-top: -80px;
  position: absolute;
  top: 50%;
  width: 100%;
}

.title {
  font-size: 50px;
  font-weight: 300;
  color: #999;
  text-transform: uppercase;
}

.message {
  font-size: 25px;
  font-weight: 300;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageError.vue